"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
import { useEffect, useRef, useState } from "react";
export default function Hero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 20;
      const y = (e.clientY / window.innerHeight - 0.5) * 20;
      setMousePosition({
        x,
        y
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);
  return <section className="relative min-h-screen w-full overflow-hidden">
      {}
      <div ref={parallaxRef} className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)]" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515187/img/dubai_skyline_dusk.png)",
      transform: `translate(${mousePosition.x}px, ${mousePosition.y}px) scale(1.1)`
    }} />

      {}
      <div className="absolute inset-0 bg-secondary/40" />

      {}
      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-6 py-20 text-center">
        {}
        <div ref={headlineRef} className="max-w-5xl transition-all duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)]" style={{
        opacity: headlineVisible ? 1 : 0,
        transform: headlineVisible ? "translateY(0)" : "translateY(20px)"
      }}>
          <h1 className="font-display text-5xl font-bold leading-tight text-foreground-dark md:text-6xl lg:text-7xl">
            The Gold Standard in Audit, Tax & Compliance
          </h1>
          <p className="mt-6 text-lg text-foreground-dark/90 md:text-xl">
            Dubai-based professional services delivering authoritative financial expertise with local market precision
          </p>
        </div>

        {}
        <div className="mt-8 h-1 w-0 transition-all duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)] !bg-[hsl(22,78%,26%)]" style={{
        width: headlineVisible ? "12rem" : "0"
      }} />

        {}
        <div ref={ctaRef} className="mt-12 flex flex-col gap-4 sm:flex-row transition-all duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)]" style={{
        opacity: ctaVisible ? 1 : 0,
        transform: ctaVisible ? "translateY(0)" : "translateY(20px)"
      }}>
          <Link to="/BookConsultationPage" className="group inline-flex items-center justify-center gap-2 rounded-md px-8 py-4 font-semibold text-foreground-primary shadow-medium transition-all duration-[80ms] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring !bg-[hsl(22,78%,26%)] hover:-translate-y-0.5 hover:bg-primary-hover hover:shadow-strong active:translate-y-0 active:bg-primary-active">
            Book a Consultation
            <ArrowRight className="h-5 w-5 transition-transform duration-[80ms] group-hover:translate-x-1" />
          </Link>
          <Link to="/ServicesPage" className="inline-flex items-center justify-center gap-2 rounded-md border border-foreground-dark/20 px-8 py-4 font-semibold text-foreground-dark backdrop-blur-sm transition-all duration-[80ms] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring !bg-[hsl(22,78%,26%)] hover:-translate-y-0.5 hover:bg-foreground-dark/20 hover:shadow-medium active:translate-y-0">
            Explore Services
          </Link>
        </div>

        {}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <div className="h-12 w-8 rounded-full border-2 border-foreground-dark/30">
            <div className="mx-auto mt-2 h-2 w-2 animate-pulse rounded-full !bg-[hsl(15,75%,28%)]" />
          </div>
        </div>
      </div>
    </section>;
}